import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthUpdateCredentialsRequestBody,
  AuthUpdateCredentialsResponse,
} from "./types";

export class AuthUpdateCredentialsAPI extends BaseAPI<
  AuthUpdateCredentialsRequestBody,
  AuthUpdateCredentialsResponse
> {
  protected route = ApiRoutes.auth.update_credentials;
  protected method = RequestMethod.POST;
  protected displayError = false;
}
